import CommonCreate from "@/components/common/Create"
import { vendorForm } from "@/utils/objects"
import { useState } from "react"
import VendorForm from "./VendorForm"

const VendorsCreate = () => {
    const [formProp, setFormProp] = useState(vendorForm)

    return (
        <CommonCreate title="New vendor" resource="vendors" data={formProp}>
            <VendorForm formProp={formProp} setFormProp={setFormProp} />
        </CommonCreate>
    )
}

export default VendorsCreate